import { NodeSource, TreeAdapter, TreeOptions, TreeSource } from "@omegagrid/tree";
import rp from "@reporting/rp-app-host";
import { Accounting } from "@reporting/rp-types/core";
import { MergeDiffItem, MergeKind, MergeResult } from "@reporting/rp-types/etl";

/**
 * Transport for the cross-accounting ETL merge editor
 */
export class EtlMergeEditorAdapter {

	get client() { return rp.ms('etl'); }

	getThreadTypes() {
		return this.client.get<{ k: string, v: string }[]>('threadTypes');
	}

	getDiff(source: number, kind?: MergeKind) {
		return this.client.get<MergeDiffItem[]>('merge/diff', kind ? { source, kind } : { source });
	}

	/** Raw content of one thread/file in the given accounting (text/plain). */
	getContent(a: number, kind: MergeKind, id: number) {
		return this.client.get<string>('merge/content', { a, kind, id }, { parseResponse: false });
	}

	apply(source: number, items: MergeDiffItem[]) {
		return this.client.post<MergeResult>('merge/apply', { source, items });
	}
}

/**
 * Source-accounting picker for the merge editor: a searchable, single-select list of accountings
 */
export class AccountingTreeAdapter extends TreeAdapter {

	private items: NodeSource[];

	async getTree(): Promise<TreeSource> {
		if (this.items) return this.items;
		const accountings = await rp.ms('accounting').get<Accounting[]>('accountings', {
			fields: ['accounting', 'company'],
			where: `ACCOUNTING <> ${rp.accountingProvider.a}`,
		});
		this.items = (accountings ?? []).map(a => ({ k: String(a.accounting), v: `${a.accounting} ${a.company ?? ''}` }));
		return this.items;
	}

	getOptions(): Partial<TreeOptions> {
		return { search: true, selectMode: 'single', autoClose: true, checkboxes: false };
	}
}
